import React, { useState, useEffect } from "react";
//MUI
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
//Componentsthat
import AdminMenu from "../../components/AdminMenu/index";
import ManageProfile from "../../components/Profile/ManageProfile";
import WideLayout from "../../layouts/AdminMainLayout";
import FactorManager from "../../components/factorManager/Index";
import ManageComments from "../../components/ManageComments/ManageComments";
import ManageContactUsMSGs from "../../components/ManageContactUsMSGs/index";
import AdminBookmarks from "../../components/Profile/AdminBookmarks";
import ManageMagazine from "../../components/ManageMagazine/ManageMagazine";
import ManageUsers from "../../components/ManageUsers/ManageUsers";
import ProductsList from "../../components/ManageProducts/ProductsList";
import ProductInsert from "../../components/ManageProducts/ProductInsert";
import ProductEdit from "../../components/ManageProducts/ProductEdit";

const AdminProfile = ({ history, tab, pid, tPage, mainCat, subCat, secCat }) => {
    // state Variables
    // isProfile,isFactors,isProducts,isUsers,isMessages,isPageManager,isComments,isHealth
    const content = [
        { value: "isProducts-List", component: <ProductsList history={history} tPage={tPage} mainCat={mainCat} subCat={subCat} secCat={secCat} pid={pid} /> },
        { value: "isProducts-Insert", component: <ProductInsert history={history} /> },
        { value: "isProducts-Edit", component: <ProductEdit pid={pid} history={history} /> },
        { value: "isProfile", component: <ManageProfile /> },
        { value: "isFactors", component: <FactorManager /> },
        { value: "isComments", component: <ManageComments /> },
        { value: "isMessages", component: <ManageContactUsMSGs /> },
        { value: "isUsers", component: <ManageUsers /> },
        { value: "isPageManager", component: <ManageComments /> },
        { value: "isHealth", component: <ManageMagazine /> },
        { value: "isBookmarks", component: <AdminBookmarks /> },
    ];
    const [stateManager, setStateManager] = useState("isProfile");
    const [width, setWidth] = useState(window.innerWidth);

    let resizeWindow = () => {
        setWidth(window.innerWidth);
    };
    const toggleState = (name) => {
        setStateManager(name);
    };

    useEffect(() => {

        if (tab === "" || tab === "profile") {
            setStateManager("isProfile")
        }
        else if (tab === "update-information") {
            setStateManager("isProfile")
        }
        else if (tab === "products-list") {
            setStateManager("isProducts-List")
        }
        else if (tab === "products-edit") {
            setStateManager("isProducts-Edit")
        }
        else if (tab === "products-insert") {
            setStateManager("isProducts-Insert")
        }
        else if (tab === "factors") {
            setStateManager("isFactors")
        }
        else if (tab === "comments") {
            setStateManager("isComments")
        }
        else if (tab === "health") {
            setStateManager("isHealth")
        }
        else if (tab === "pageManager") {
            setStateManager("isPageManager")
        }
        else if (tab === "users") {
            setStateManager("isUsers")
        }
        else if (tab === "messages") {
            setStateManager("isMessages")
        }
        else if (tab === "bookmarks") {
            setStateManager("isBookmarks")
        }
        else if (tab === "update-information") {
            setStateManager("isProfile")
        }
        else if (tab === "manage-invoices" || tab === "unpaid-invoices") {
            setStateManager("isFactors")
        }

        return history.listen((location) => {
            if (!window.location.hash) {
                var loc = location.pathname;
                var res = loc.split("/");
                if (res.length >= 3) {
                    if (stateManager !== res[2]) {
                        if (res[2] === "bookmarks") {
                            setStateManager("isBookmarks")
                        } else if (res[2] === "update-information" || res[2] === "profile") {
                            setStateManager("isProfile")
                        }
                        else if (res[2] === "products-list") {
                            setStateManager("isProducts-List")
                        }
                        else if (res[2] === "products-edit") {
                            setStateManager("isProducts-Edit")
                        }
                        else if (res[2] === "products-insert") {
                            setStateManager("isProducts-Insert")
                        }
                        else if (res[2] === "factors") {
                            setStateManager("isFactors")
                        }
                        else if (res[2] === "comments") {
                            setStateManager("isComments")
                        }
                        else if (res[2] === "health") {
                            setStateManager("isHealth")
                        }
                        else if (res[2] === "pageManager") {
                            setStateManager("isPageManager")
                        }
                        else if (res[2] === "users") {
                            setStateManager("isUsers")
                        }
                        else if (res[2] === "messages") {
                            setStateManager("isMessages")
                        }
                        else if (res[2] === "manage-invoices" || res[2] === "unpaid-invoices") {
                            setStateManager("isFactors")
                        }
                    }
                }
                else if (res.length === 2) {
                    setStateManager("isProfile")
                }
            }
        })

    }, [history])

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, [])

    return (
        <WideLayout>
            {width > 1024 && (<Grid container justify="center">
                <Grid item md={2}>
                    <AdminMenu history={history} action={toggleState} active={stateManager} />
                </Grid>
                <Grid item md={10}>
                    {content.map((item) => item.value === stateManager && item.component)}
                </Grid>
            </Grid>)}
            {width < 1024 && (
                <Box fontWeight="bold" color="red" height="60vh" display="flex" alignItems="center" justifyContent="center" textAlign="center">
                    بخش مدیریت در موبایل و تبلت هایی با عرض کم قابل نمایش نمی باشد.
                </Box>)}

        </WideLayout>
    );
};

export default AdminProfile;
